import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import 'rxjs/add/observable/of';
import { FiltrosFondo } from 'app/models/FiltrosFondo';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { ServifinPdfService } from 'app/services/operaciones/servifin-pdf/servifin-pdf.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-inversionistas',
  templateUrl: './listado-inversionistas.component.html',
  styleUrls: ['./listado-inversionistas.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoInversionistasComponent implements OnInit {
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  servifinMode = environment.SERVIFIN_MODE;
  nitLabel = environment.LABEL_RUC || 'NIT';
  DTOFiltrosFondo: FiltrosFondo = new FiltrosFondo();
  loading: boolean;
  inversiones: any = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['idComprobante', 'Fecha_Registro', 'Codigo_de_Valor', 'RUT_Titular', 'VNPP_ICLV', 'acciones'];
  dataSource: any;

  constructor(
    private documentosNegociableService: DocumentoNegociableService,
    private datepipe: DatePipe,
    private servifinPdfService: ServifinPdfService
  ) {
    this.DTOFiltrosFondo.FechaIni = this.datepipe.transform(moment().add(-320, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosFondo.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
  }

  ngOnInit() {
    if (!this.servifinMode) {
      this.displayedColumns = this.displayedColumns.filter(c => c !== 'acciones');
    }
    this.ListadoFondoInversionistas();
  }

  ListadoFondoInversionistas() {
    this.loading = true;
    this.DTOFiltrosFondo.FechaIni = this.datepipe.transform(this.DTOFiltrosFondo.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosFondo.FechaFin = this.datepipe.transform(this.DTOFiltrosFondo.FechaFin, 'yyyy-MM-dd');
    this.documentosNegociableService.ListarDocumentosNICLV(this.DTOFiltrosFondo)
      .subscribe(
        res => {
          this.inversiones = res;
          this.dataSource = new MatTableDataSource(this.inversiones);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
        }, err => {
          Swal.fire({
            title: "¡Algo salió mal!",
            text: err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        });
  }

  exportarPdfServifin(tipo: string, element?: any) {
    const linea = element ? {
      Doc: element.Codigo_de_Valor,
      Vr_Inversion: element.VNPP_ICLV,
      Tasa_Compra: 15.5,
      Vr_Futuro: element.VNPP_ICLV,
      Rendimientos: 0,
      Retefuente: 0,
      ReteCree: 0,
      Neto_Recibir: element.VNPP_ICLV,
      Vr_Presente: element.VNPP_ICLV,
      Id_Cuota: 1,
      Concepto: element.Codigo_de_Valor,
    } : null;
    const payload: any = {
      Comprador: element ? element.RUT_Titular : 'Comprador',
      Nit_Comprador: element ? element.RUT_Titular : '',
      Fecha: new Date().toISOString().substring(0, 10),
      Fecha_Corte: new Date().toISOString().substring(0, 10),
      Numero_Operacion: element ? ('OPE-1-' + element.idComprobante) : '',
      Lineas: linea ? [linea] : [],
      Cuotas: linea ? [linea] : [],
      Totales: element ? {
        Vr_Inversion: element.VNPP_ICLV,
        Vr_Presente: element.VNPP_ICLV,
        Vr_Futuro: element.VNPP_ICLV,
        Vr_Compra: element.VNPP_ICLV,
        Rendimientos: 0,
        Retefuente: 0,
        ReteCree: 0,
        Neto_Recibir: element.VNPP_ICLV,
      } : {},
    };
    this.servifinPdfService.generarPdf(payload, tipo).subscribe(blob => {
      this.servifinPdfService.descargarBlob(blob, `Servifin_${tipo}.pdf`);
    });
  }
}